
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c04323","d":"M20 19.5L0 39V26.148L6.817 19.5 0 12.853V0z"}})])
          )
        }
      }
    